import React, { useState } from 'react';
import './ContactUs.css';
import HeaderContent from './Header';
import { storeQuery } from '../Network/APIService';
import Footer from './Footer';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e: any) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) {
      alert('Please fill in all fields.');
      return;
    }
    alert(`Thank you, ${formData.name}. Your message has been submitted.`);
    setFormData({ name: '', email: '', message: '' });
    
    storeQuery({ name: '', email: '', message: '' });
  };

  return (
    <div className="contact-page-bg">
      <HeaderContent />
      <div className="contact-container">
        <h2 className="contact-heading">Contact Us</h2>

        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
          />

          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
          />

          <button type="submit">Submit Query</button>
        </form>

        <div className="contact-info">
          <h3 style={{color:'black'}}>Email</h3>
          <p style={{color:'black', fontSize:15}}>admin@despatchdost.com</p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
